<template>
  <div>
    <div class="elevation-3">
      <v-container class="pa-0">
        <v-toolbar color="white" light flat>
          <a href="https://kccte.pittstate.edu/" class="no-text-deco" target="_blank">
            <v-toolbar-title>
              <img src="/dist/images/updated-psu-logo.png" style="height:50px" class="mr-2">
            </v-toolbar-title>
          </a>
          <v-spacer />
          <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="showDrawer = !showDrawer" />
          <request-author-access v-if="!isAdmin" :not-author="notAuthor" :is-signed-in="signedIn" class="hidden-sm-and-down" />
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn v-if="signedIn" flat :ripple="false" @click="dialog=true">
              Request Resources
            </v-btn>
            <v-btn v-for="(item, index) in navItems" :key="index" flat :href="item.href" :class="{'v-btn--active': checkActiveUrl(item.href)}" :ripple="false">
              {{ item.title }}
            </v-btn>
          </v-toolbar-items>
          <div v-if="signedIn" class="hidden-sm-and-down">
            <v-menu offset-y bottom left max-height="500" nudge-bottom="14" class="pl-3">
              <v-btn slot="activator" icon class="nav-avatar-icon">
                <v-avatar v-if="user" class="white" size="40">
                  <img :src="user.profilePicture" :alt="user.fullName">
                </v-avatar>
              </v-btn>
              <v-list dense>
                <v-subheader>{{ user.fullName }}</v-subheader>
                <v-list-tile href="/ManageAccount/Index">
                  <v-list-tile-title>Manage Account</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isAdmin" href="/Account/SupportLogin" target="_blank">
                  <v-list-tile-title>Support</v-list-tile-title>
                </v-list-tile>
                <v-list-tile href="http://kccte-authors.centralus.cloudapp.azure.com/login/" target="_blank">
                  <v-list-tile-title>Author Resources Portal</v-list-tile-title>
                </v-list-tile>
                <v-list-tile href="/Account/Logout">
                  <v-list-tile-title>Logout</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <div v-else href="/Account/Login" />
        </v-toolbar>
      </v-container>
    </div>

    <v-navigation-drawer id="drawer" v-model="showDrawer" temporary absolute width="300">
      <v-list class="pt-3">
        <v-list-tile>
          <img src="/dist/images/updated-psu-logo.png" style="max-height:30px" class="mr-2"> KCCTE Resource Library
        </v-list-tile>
      </v-list>
      <v-list class="pt-3">
        <v-list-tile v-for="(item, index) in navItems" :key="index" flat :href="item.href" :class="{'v-btn--active': checkActiveUrl(item.href)}" :ripple="false">
          {{ item.title }}
        </v-list-tile>
      </v-list>
      <v-list v-if="signedIn" class="pt-0" dense>
        <v-divider />
        <v-subheader>{{ user.fullName }}</v-subheader>
        <v-list-tile href="/ManageAccount/Index#submit-materials">
          <v-list-tile-title>Submit Materials</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="#" v-if="signedIn" flat :ripple="false" @click="dialog=true">
          <v-list-tile-title>Request Resources</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="/ManageAccount/Index">
          <v-list-tile-title>Manage Account</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="isAdmin" href="/Account/SupportLogin" target="_blank">
          <v-list-tile-title>Support</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="isAdmin" href="http://kccte-authors.centralus.cloudapp.azure.com/login/" target="_blank">
          <v-list-tile-title>Author Resources Portal</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="/Account/Logout">
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>


    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Request Resources
          </span>
        </v-card-title>
        <v-card-text>
          <p>
            Are you looking for something that is not currently available in the resource library? Submit a request below for what you need and we will reach out to authors who can help!
          </p>
          <v-textarea v-model="requestForm.content" placeholder="Enter request here" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="success" :loading="loading" @click="requestResources">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import RequestAuthorAccess from '~/Views/ManageAccount/RequestAuthorAccess.vue';
  import axios from 'axios';
  import { mapActions } from 'vuex';

  export default {
    parent: true,

    components: {
      RequestAuthorAccess,
    },

    props: {
      signedIn: {
        type: Boolean,
        default: false,
      },

      notAuthor: {
        type: Boolean,
        default: false,
      },

      isAdmin: {
        type: Boolean,
        default: false,
      },

      navItems: {
        type: Array,
        default: () => [],
      },
    },

    data: () => ({
      user: window.user,
      loading: false,
      dialog: false,
      showDrawer: false,
      requestForm: {
        content: '',
      },
    }),

    methods: {
      ...mapActions({
        setToast: 'toasts/addToGlobalToastQueue',
      }),
      checkActiveUrl(menuLink) {
        const currentUrl = window.location.pathname;
        return currentUrl === menuLink;
      },

      async requestResources() {
        this.loading = true;
        try {
          await axios.post('/api/resource-request', this.requestForm);
          this.requestForm.content = '';
          this.dialog = false;
          this.loading = false;
          this.setToast({
            color: 'green',
            message: 'Thank you for your request! We will contact you if we have any questions.',
            multiline: false,
          });
        } catch (error) {
          this.loading = false;
          this.setToast({
            color: 'danger',
            message: 'We were not able to process your request. Please try again, or contact us for additional support.',
            multiline: true,
          });
        }
      },

    },
  };
</script>